import PropTypes from 'prop-types';
import FJBlankInVideoPanel from '../../../FJMainPreview/FJBlankPanel/FJBlankInVideoPanel';
import FJCreationEditPanelContainer from '../../../FJMainPreview/FJCreationEditPanel/container/FJCreationEditPanelContainer';
import classNames from 'classnames';
import styles from './FJBrushObjectEraseRight.module.less';
import FJConstant from '../../../../constants/FJConstant';

const FJBrushObjectEraseRight = ({ isNotImage, headerTabIndex, isShow }) => {
    return (
        <div className={classNames(styles.app_right, { [styles.show]: isShow })}>
            {isNotImage ? (
                <FJBlankInVideoPanel
                    active={headerTabIndex === FJConstant.CREATIONS}
                    boxDesc='remove-objects-efficiently-create-images-professionally'
                    boxTitle='quickly-remove-unwanted-objects-using-ai'
                />
            ) : (
                <FJCreationEditPanelContainer activeHeaderTabIndex={FJConstant.CREATIONS} />
            )}
        </div>
    );
};

FJBrushObjectEraseRight.propTypes = {
    isNotImage: PropTypes.bool,
    headerTabIndex: PropTypes.string,
    isShow: PropTypes.bool,
};

export default FJBrushObjectEraseRight;
